import { Session } from "@app/shared/types";
import { dateTimeFromString } from "@app/shared/utils";
import { useUserTimezone } from "hooks/useUserTimezone";
import { DateTime } from "luxon";
import smoothscroll from "smoothscroll-polyfill";
import { CommunityEventCard } from "../community/CommunityEventCard";
smoothscroll.polyfill();

export interface EventListProps {
    events: Session[];
    currentServerTime: DateTime;
    showSpecificDate?: boolean;
}

export const EventList = (props: EventListProps): JSX.Element => {
    const { events, currentServerTime, showSpecificDate } = props;

    const timezone = useUserTimezone();

    const now = currentServerTime.setZone(timezone);

    // Filter out any events that are now over
    const filteredEvents = events.filter(
        (event) => dateTimeFromString(event.endTime, timezone) > now,
    );

    return (
        <div>
            {filteredEvents.map((event: Session) => (
                <CommunityEventCard
                    key={event.id}
                    event={event}
                    timezone={timezone}
                    currentServerTime={currentServerTime}
                    showSpecificDate={showSpecificDate}
                />
            ))}
        </div>
    );
};
